/**
 * UPCart + Discount Ninja Synchronization Script
 * 
 * Ensures UPCart reflects discounted prices by triggering a refresh after 
 * Discount Ninja (DN) updates cart properties. This handles the case where DN's
 * addition of properties changes line item keys during the first add-to-cart.
 */
(function() {
  'use strict';

  var REFRESH_INTERVALS = [300, 600, 1000, 1500, 2500];
  var pendingTimeouts = [];

  function refreshUPCart(delay) {
    if (typeof window.upcartRefreshCart === 'function') {
      window.upcartRefreshCart();
    }
  }

  function startSyncSequence() {
    // Clear any existing sync sequences to avoid overlap
    pendingTimeouts.forEach(clearTimeout);
    pendingTimeouts = [];

    // Schedule a sequence of refreshes to catch the cart after and during DN key updates
    REFRESH_INTERVALS.forEach(function(delay) {
      var timeout = setTimeout(function() {
        refreshUPCart(delay);
      }, delay);
      pendingTimeouts.push(timeout);
    });
  }

  // Listen for Discount Ninja completion events
  document.addEventListener('la:dn:cart:updated', startSyncSequence);
  document.addEventListener('la:dn:cart:mutations:processed', startSyncSequence);

  // Fallback for standard theme add-to-cart
  document.addEventListener('product:added', startSyncSequence);

})();
